import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import { Grid, Heading, Text } from "@radix-ui/themes";
import { FC, useEffect, useState } from "react";
import { Button, Input, InputProps } from "../../components";

export type LoginProps = {
  onSubmit: (customerId: string, orderId: string) => void;
  loading?: boolean;
};

export const Login: FC<LoginProps> = (props) => {
  const { onSubmit, loading } = props;
  const params = new URLSearchParams(window.location.search);
  const paramCustomerId = params.get("customerid") ?? "";
  const paramOrderId = params.get("orderid") ?? "";

  const [customerId, setCustomerId] = useState(paramCustomerId);
  const [orderId, setOrderId] = useState(paramOrderId);

  const submit = () => {
    onSubmit(customerId, orderId);
  };

  const handleKeyDown: InputProps["onKeyDown"] = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      submit();
    }
  };

  useEffect(() => {
    if (paramCustomerId !== "" && paramOrderId !== "") {
      onSubmit(paramCustomerId, paramOrderId);
    }
  }, []);

  const buttonIsDisabled = customerId === "" || orderId === "";

  return (
    <Grid gap="2">
      <Heading as="h2" size="4" mt="3">
        Ihr Auftragsstatus im Detail
      </Heading>
      <Text mb="3">
        Geben Sie Ihre Kunden- und AB-Auftragsnummer ein, um den aktuellen Status
        Ihres Auftrags einzusehen. Sie erhalten eine Übersicht aller Positionen.
        Die Informationen werden fortlaufend aktualisiert.
      </Text>

      <Grid columns={{ md: "2" }} gap="2">
        <div>
          <Text as="label">
            Kundennummer:
            <Input
              placeholder="1234567"
              value={customerId}
              onChange={(value) => setCustomerId(value)}
              disabled={loading}
              onKeyDown={handleKeyDown}
            />
          </Text>
        </div>
        <div>
          <Text as="label">
            AB-Auftragsnummer:
            <Input
              placeholder="54321"
              value={orderId}
              onChange={(value) => setOrderId(value)}
              disabled={loading}
              type="number"
              onKeyDown={handleKeyDown}
            />
          </Text>
        </div>
      </Grid>
      <Button loading={loading} onClick={submit} disabled={buttonIsDisabled}>
        <MagnifyingGlassIcon />
        Suchen
      </Button>
    </Grid>
  );
};
